import {SelectInputComponent} from './select-input/select-input.component';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DirectivesModule} from '../directives/directives.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SelectPreviewComponent} from './select-preview/select-preview.component';
import {AppFileInputComponent} from './app-file-input/app-file-input.component';
import {DragDirective} from './app-file-input/dragDrop.directive';
import {CookieService} from 'ngx-cookie-service';
import {RadioInputComponent} from './radios/app-radio-input.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    SelectInputComponent,
    SelectPreviewComponent,
    AppFileInputComponent,
    DragDirective,
    RadioInputComponent,
  ],
  imports: [CommonModule, DirectivesModule, FormsModule, ReactiveFormsModule, MatProgressSpinnerModule],
  exports: [SelectInputComponent, SelectPreviewComponent, AppFileInputComponent, RadioInputComponent],
  providers: [CookieService],
})
export class InputsModule {}
